const CAREER_CLUSTERS = [
  {
    id: 1,
    title: "Advanced Manufacturing",
    things: [
      "Building or fixing things",
      "Using machines or tools",
      "Following step-by-step directions",
      "Creating new inventions or products",
      "Making processes work faster and smoother",
    ],
    traits: [
      "I pay attention to small details",
      "I'm careful and focused",
      "I enjoy solving technical problems",
      "I like figuring out how things work",
      "I'm good at using tools",
    ],
    problems: [
      "How do we make things faster and better?",
      "How can we use less waste in workplaces?",
      "How can we make the things people need closer to home?",
      "How do we make safer tools and products?",
      "How can we fix broken machines quickly?",
    ],
  },

  {
    id: 2,
    title: "Agriculture",
    things: [
      "Gardening or growing plants",
      "Taking care of animals",
      "Learning how water could be used to grow food",
      "Using tools or machines",
      "Trying new foods and wondering where they come from",
    ],
    traits: [
      "I like working with my hands",
      "I believe both people and nature need what it takes to thrive",
      "I enjoy solving real-world problems",
      "I'm patient",
      "I like being outside",
    ],
    problems: [
      "How can we grow healthy food for everyone?",
      "How do we take care of the land and living things?",
      "How can we save more clean water?",
      "How do we get food to people who need it?",
      "How can we limit damaging land when we use it?",
    ],
  },

  {
    id: 3,
    title: "Arts, Entertainment & Design",
    things: [
      "Writing stories, poems, or scripts",
      "Performing in music, dance, or theater",
      "Creating videos, taking photos, or making animations",
      "Working on costumes, sets, or props",
      "Drawing, painting, or making designs",
    ],
    traits: [
      "I like creating and sharing my ideas",
      "I like performing or entertaining",
      "I enjoy making things look good",
      "I like sharing my ideas in ways that influence people",
      "I like using my imagination",
    ],
    problems: [
      "How can art tell powerful stories?",
      "How do we use creativity to connect people?",
      "How can technology and art work together?",
      "How do we share news in a way that is both honest and easy to understand?",
      "How can creativity help people understand big ideas?",
    ],
  },
    {
    id: 4,
    title: "Construction",
    things: [
      "Building or designing outdoor spaces, houses, or other things",
      "Helping plan how something should be built",
      "Using tools and machines",
      "Measuring and cutting materials",
      "Solving problems about how something should be built",
    ],
    traits: [
      "I like building things",
      "I follow directions carefully",
      "I like hands-on work",
      "I enjoy solving problems step by step",
      "I'm dependable and responsible",
    ],
    problems: [
      "How do we build safe, strong places to live?",
      "How can we make buildings that use less energy?",
      "How can we fix and upgrade old buildings?",
      "How do we build things that last a long time?",
      "How do we make construction work safer?",
    ],
  },

  {
    id: 5,
    title: "Digital Technology",
    things: [
      "Solving puzzles or coding challenges",
      "Working with computers or apps",
      "Playing or making video games",
      "Fixing things when they break",
      "Using AI or digital tools",
    ],
    traits: [
      "I like figuring out problems",
      "I enjoy learning new technology",
      "I pay attention to details",
      "I'm patient and a good problem solver",
      "I like using technology to be creative",
    ],
    problems: [
      "How do we tell stories with data?",
      "How can we use technology to make life easier?",
      "How do we build new apps or websites that meet an unmet need?",
      "How can we stop hackers and protect privacy?",
      "How do we help people learn and connect online?",
    ],
  },

  {
    id: 6,
    title: "Education",
    things: [
      "Helping people learn new things",
      "Explaining things in simple ways",
      "Tutoring or mentoring others",
      "Leading group projects or activities",
      "Coming up with fun ways to teach something",
    ],
    traits: [
      "I like helping others",
      "I'm a good listener",
      "I'm patient and kind",
      "I'm curious and love to learn",
      "I enjoy speaking or presenting",
    ],
    problems: [
      "How can learning be fun for everyone?",
      "How do we connect learning to culture, family, and community?",
      "How can we support different ways of learning?",
      "How do we make places for learning feel safe and welcoming?",
      "How can education and training help people have a better life?",
    ],
  },

  {
    id: 7,
    title: "Energy & Natural Resources",
    things: [
      "Working with new and emerging technologies",
      "Studying science or nature",
      "Learning how solar panels, wind turbines, or electric cars work",
      "Working on outdoor projects",
      "Helping keep parks, rivers, or forests clean",
    ],
    traits: [
      "I care about the environment",
      "I'm curious about how the Earth works",
      "I enjoy learning how systems work",
      "I like working outside",
      "I want to protect natural places",
    ],
    problems: [
      "How can we use energy without harming the planet?",
      "How do we protect animals and wild spaces?",
      "How do we make energy cleaner and safer?",
      "How can we stop pollution and waste?",
      "How do we balance human needs with nature?",
    ],
  },
    {
    id: 8,
    title: "Financial Services",
    things: [
      "Managing money or saving for goals",
      "Playing games with strategy or math",
      "Keeping track of spending",
      "Learning about investing or business",
      "Helping friends understand money",
    ],
    traits: [
      "I'm organized and careful",
      "I like working with numbers",
      "I'm honest and responsible",
      "I'm curious about the economy",
      "I'm a good explainer",
    ],
    problems: [
      "How do we help people make smart money choices?",
      "How do we plan for big life expenses?",
      "How do we protect people from scams?",
      "How do we help people grow their savings?",
      "How can we use money to build wealth for the future?",
    ],
  },

  {
    id: 9,
    title: "Healthcare & Human Services",
    things: [
      "Helping people feel better",
      "Learning about the body or medicine",
      "Having caring conversations with people",
      "Giving first aid or doing wellness activities",
      "Volunteering or caring for others",
    ],
    traits: [
      "I'm caring and patient",
      "I like science and health",
      "I'm a good listener",
      "I stay calm in tough situations",
      "I like making a difference",
    ],
    problems: [
      "How can we take care of people who are sick?",
      "How do we help people live healthier lives?",
      "How can we support mental health?",
      "How do we respond in emergencies?",
      "How do we make sure everyone gets care in their communities?",
    ],
  },

  {
    id: 10,
    title: "Hospitality, Events & Tourism",
    things: [
      "Cooking or preparing food",
      "Planning trips or events",
      "Helping visitors feel welcome",
      "Decorating or preparing for a big party",
      "Learning about different places or cultures",
    ],
    traits: [
      "I'm creative and enjoy making people happy",
      "I'm organized and enthusiastic",
      "I'm friendly and helpful",
      "I like busy, active places",
      "I'm curious about the world",
    ],
    problems: [
      "How do we make healthy meals that taste good?",
      "How can we help people enjoy their time off?",
      "How do we create great experiences for visitors?",
      "How can we make travel easier and more fun?",
      "How can we make tourism good for local communities?",
    ],
  },

  {
    id: 11,
    title: "Management & Entrepreneurship",
    things: [
      "Starting new projects or businesses",
      "Leading a team",
      "Helping people grow",
      "Solving complex problems",
      "Finding ways to earn money",
    ],
    traits: [
      "I'm a self-starter",
      "I'm confident and organized",
      "I'm good at talking to people",
      "I like setting goals",
      "I'm creative and motivated",
    ],
    problems: [
      "How can we grow good ideas into real businesses?",
      "How do we help businesses run better?",
      "How do we create products people love?",
      "How can people be motivated to do their best work?",
      "How can businesses make a positive difference?",
    ],
  },
    {
    id: 12,
    title: "Marketing & Sales",
    things: [
      "Using social media to engage people",
      "Creating eye-catching designs",
      "Persuading people or giving presentations",
      "Coming up with ways to sell things",
      "Finding out what people like and don't like",
    ],
    traits: [
      "I'm outgoing and persuasive",
      "I'm creative and like making things look great",
      "I'm confident and clear",
      "I'm good at explaining things",
      "I'm observant and analytical",
    ],
    problems: [
      "How do we get the right message to the right people?",
      "How can we help people find products they love?",
      "How do we build trust with customers?",
      "How do we understand what people want?",
      "How do we protect people from scams or unsafe products?",
    ],
  },

  {
    id: 13,
    title: "Public Service & Safety",
    things: [
      "Helping during a crisis",
      "Learning how to keep people safe",
      "Learning about laws and government",
      "Helping the community meet a need",
      "Supporting justice or public safety",
    ],
    traits: [
      "I'm fair and honest",
      "I'm dependable and quick-thinking",
      "I'm calm in stressful situations",
      "I like solving big problems",
      "I care about fairness and service",
    ],
    problems: [
      "How do we keep communities safe?",
      "How do we respond to disasters or danger?",
      "How do we protect people's rights?",
      "How do we prepare for future challenges?",
      "How can we make sure government programs reach all people?",
    ],
  },

  {
    id: 14,
    title: "Supply Chain & Transportation",
    things: [
      "Making sure things get where they belong",
      "Planning routes or schedules",
      "Being around vehicles, ships, or planes",
      "Packing, shipping, or tracking orders",
      "Fixing things when they break",
    ],
    traits: [
      "I'm focused and reliable",
      "I'm organized and detail-oriented",
      "I like machines and engines",
      "I like systems and logistics",
      "I like to keep things working well",
    ],
    problems: [
      "How do we get products where they need to go?",
      "How do we make deliveries faster and safer?",
      "How can we move things in smart ways?",
      "How do we keep shelves stocked and stores running?",
      "How can we stop things from breaking down?",
    ],
  },
];

export default CAREER_CLUSTERS;
